import {
  ChangeDetectorRef,
  Component,
  computed,
  inject,
  OnDestroy,
  OnInit,
  ViewEncapsulation,
  ChangeDetectionStrategy,
} from '@angular/core';
import $ from 'jquery';
import { map, Subject, takeUntil } from 'rxjs';
// import { takeUntil } from 'rxjs/operators';
import { navigation } from 'src/app/navigation/navigation';
import { Router } from '@angular/router';
import { AuthenticationService } from '@_services/authentication.service';
import { BehaviorService } from '@_services/Behavior.service';
import { MainAPiServiceService } from '@_services/main-api-service.service';
import { Media } from '@/app/core/media';
import { FuseConfigService } from '@_services/config.service';
import { toSignal } from '@angular/core/rxjs-interop';

@Component({
  selector: 'vertical-layout-1',
  templateUrl: './layout-1.component.html',
  styleUrls: ['./layout-1.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class VerticalLayout1Component implements OnInit, OnDestroy {
  fuseConfig: any;
  navigation: any;
  isOpenNotifications: boolean = false;
  isNotificationsOpen: boolean = false;
  isQuickPanelOpen: boolean = false;
  isTimerPinned: boolean = false;
  rightSidebarWidth: number = 0;
  isOpenWarning: boolean = false;
  isOpenNotificationsPermission: boolean = false;
  UserData: any = {};
  selectedColore: string;
  warningColor: string = '#cc3d76';
  taskData: any = [];
  isTaskData: boolean = false;
  folderHideshow = localStorage.getItem('taskReminderFolderHideshow') !== 'false';
  intervel: any;
  private snoozeHiddenGuid: string;
  private snoozeReopenTimer: ReturnType<typeof setTimeout>;
  private reminderMinutes = 5;
  private readonly snoozeStorageKey = 'taskReminderSnooze';
  private readonly folderStorageKey = 'taskReminderFolderHideshow';
  toolbarsetting: any;
  preferenceObjectData: any;
  private _unsubscribeAll: Subject<any>;

  private media = inject(Media);

  protected isMobile = computed(() => this.media.match(`(max-width: 1023px)`)());

  currentUser: any = JSON.parse(localStorage.getItem('currentUser') || '{}');

  isLoggedInUser: boolean = !!this.currentUser?.UserGuid;

  // accessing favicon link tag
  favIcon: HTMLLinkElement = window.document.querySelector('#appIcon');

  sidebarFoldedState = JSON.parse(
    localStorage.getItem('sidebar_fold_unfold') || 'false',
  ) as boolean;

  isSidebarCollapsed = toSignal(
    this.behaviorService.isMenuFolded$.pipe(map((isFolded) => isFolded ?? this.sidebarFoldedState)),
    { initialValue: this.sidebarFoldedState },
  );

  /**
   * Constructor
   *
   * @param {FuseConfigService} _fuseConfigService
   */
  constructor(
    private _fuseConfigService: FuseConfigService,
    private authenticationService: AuthenticationService,
    private behaviorService: BehaviorService,
    private _mainAPiServiceService: MainAPiServiceService,
    private cd: ChangeDetectorRef,
    public router: Router,
  ) {
    /*
        Used of this behvoiur :: This behaviour used to show all login API data which we used for the current user
        */
    this.authenticationService.currentUserSubject$.subscribe((result: any) => {
      if (result) {
        this.UserData = result;
        this.isLoggedInUser = !!(result?.UserGuid || result?.USERGUID);

        this.selectedColore =
          this.UserData.PRODUCTTYPE == 'Solicitor' ? '#43a047' : 'rebeccapurple';
        if (
          this.UserData &&
          (this.UserData.REGISTRATIONSTATUS == 'Expires Soon' ||
            this.UserData.REGISTRATIONSTATUS == 'Grace Period' ||
            this.UserData.REGISTRATIONSTATUS == 'Expired' ||
            this.UserData.REGISTRATIONSTATUS == 'Trial Expired' ||
            this.UserData.REGISTRATIONSTATUS == 'Trial Expires Soon' ||
            this.UserData.REGISTRATIONSTATUS == 'Current Trial' ||
            ((this.UserData.REGISTRATIONSTATUS == 'Using New UI' ||
              this.UserData.REGISTRATIONSTATUS !== '') &&
              this.UserData.REGISTRATIONMESSAGE &&
              this.UserData.REGISTRATIONMESSAGE !== ''))
        ) {
          this.isOpenNotifications = true;
          this.isOpenWarning = true;
          if (
            this.UserData.REGISTRATIONSTATUS == 'Using New UI' ||
            this.UserData.REGISTRATIONSTATUS !== ''
          ) {
            this.behaviorService.permissionCheckforHeight$.next(true);
          } else {
            this.behaviorService.permissionCheckforHeight$.next(false);
          }
          // this.behaviorService.permissionCheckforHeight$.next(true);
        }
      } else {
        this.isLoggedInUser = false;
        this.isOpenNotifications = false;
        this.isOpenWarning = false;
        this.UserData = {};
        this.rightSidebarWidth = 0;
        this.clearSnoozePersist();
        this.setFolderHideshow(true, true);
        this.snoozeHiddenGuid = null;
        this.reminderMinutes = 5;
        clearTimeout(this.snoozeReopenTimer);
        this.behaviorService.rightSidebarWidth$.next(0);
        this.behaviorService.isQuickPanelOpen$.next(false);
        this.behaviorService.isTimerPinned$.next(false);
        this.behaviorService.isSetupGuideOpen$.next(false);
        this.behaviorService.isNotificationsOpen$.next(false);
        setTimeout(() => this.cd.detectChanges());
      }
    });
    this.behaviorService.toolBaarSetting$.subscribe((result) => {
      this.toolbarsetting = result;
      // this.target = (result && result.OPENINNEWTABWINDOWS) ? result.OPENINNEWTABWINDOWS : {};
      // this.target = (this.toolbarsetting && this.toolbarsetting.OPENINNEWTAB) ? "_blank" : "_self";
    });
    this.behaviorService.permissionCheck$.subscribe((result) => {
      this.isOpenNotificationsPermission = result;
      // permissionCheck$ starts as false and is not part of registration status.
      // Applying that initial false hides the banner on refresh. Only an explicit
      // true may open it; registration status above already decides the banner.
      if (result == true) {
        this.isOpenNotifications = true;
        this.behaviorService.permissionCheckforHeight$.next(true);
        this.cd.markForCheck();
      }
    });
    this.behaviorService.GetPreferences$.subscribe((result) => {
      if (result) {
        this.preferenceObjectData = result;
      } else {
        this.preferenceObjectData = JSON.parse(localStorage.getItem('currentUser'));
      }
      // if (this.preferenceObjectData && this.preferenceObjectData?.NAVBARFOLDED) {
      //     setTimeout(() => {
      //         $('.navbar-fuse-sidebar').addClass('folded');
      //     }, 1000);
      // } else {
      //     $('.navbar-fuse-sidebar').removeClass('folded');
      // }
    });
    this.navigation = navigation;
    this._unsubscribeAll = new Subject();
    if (localStorage.getItem('theme_type') == 'theme-yellow-light') {
      // this.greenTheme = true;
      this.favIcon.href = 'assets/images/logos/sm-silq-small-user2.png';
    } else if (localStorage.getItem('theme_type') == 'theme-blue-gray-dark') {
      // this.greenTheme = true;
      this.favIcon.href = 'assets/images/logos/sm-silq-small-user2.png';
    } else {
      // this.defultTheme = true;
      this.favIcon.href = 'assets/images/logos/sm-silq-small.png';
    }
    this.restoreSnoozeState();
  }
  isTaskDataBack(Evnt) {
    this.isTaskData = Evnt || !!this.snoozeHiddenGuid;
  }

  onFolderHideshowChange(show: boolean) {
    this.setFolderHideshow(show, true);
  }

  onSnoozeComplete(event: { taskGuid: string; reopenAfterMs: number; reminderMinutes: number }) {
    this.snoozeHiddenGuid = event.taskGuid;
    this.reminderMinutes = event.reminderMinutes || 5;
    this.setFolderHideshow(false);
    this.getTask(event.taskGuid);
    this.isTaskData = true;
    this.persistSnooze(event.reopenAfterMs);
    this.scheduleSnoozeReopen(event.reopenAfterMs);
  }

  private setFolderHideshow(show: boolean, force = false) {
    if (show && !force && this.isSnoozePending()) {
      return;
    }
    this.folderHideshow = show;
    localStorage.setItem(this.folderStorageKey, JSON.stringify(show));
  }

  private isSnoozePending(): boolean {
    const saved = this.readSnoozePersist();
    return !!saved && saved.reopenAt > Date.now();
  }

  private readSnoozePersist(): any {
    try {
      const saved = JSON.parse(localStorage.getItem(this.snoozeStorageKey) || 'null');
      const userGuid = JSON.parse(localStorage.getItem('currentUser') || '{}')?.UserGuid;
      if (!saved?.reopenAt || saved.userGuid !== userGuid) {
        return null;
      }
      return saved;
    } catch {
      return null;
    }
  }

  private persistSnooze(reopenAfterMs: number) {
    const userGuid = JSON.parse(localStorage.getItem('currentUser') || '{}')?.UserGuid;
    if (!userGuid) {
      return;
    }
    localStorage.setItem(
      this.snoozeStorageKey,
      JSON.stringify({
        userGuid,
        taskGuid: this.snoozeHiddenGuid,
        reminderMinutes: this.reminderMinutes,
        reopenAt: Date.now() + reopenAfterMs,
        folderHideshow: false,
      }),
    );
  }

  private clearSnoozePersist() {
    localStorage.removeItem(this.snoozeStorageKey);
    localStorage.removeItem(this.folderStorageKey);
  }

  private restoreSnoozeState() {
    const saved = this.readSnoozePersist();
    const storedFolder = localStorage.getItem(this.folderStorageKey);
    if (saved) {
      this.snoozeHiddenGuid = saved.taskGuid;
      this.reminderMinutes = saved.reminderMinutes || 5;
      const remaining = saved.reopenAt - Date.now();
      if (remaining <= 0) {
        this.openAfterSnooze();
        return;
      }
      this.setFolderHideshow(storedFolder === 'true', true);
      this.scheduleSnoozeReopen(remaining);
      return;
    }
    this.snoozeHiddenGuid = null;
    if (storedFolder === 'false') {
      this.setFolderHideshow(false);
      return;
    }
    this.setFolderHideshow(true, true);
  }

  private scheduleSnoozeReopen(ms: number) {
    clearTimeout(this.snoozeReopenTimer);
    this.snoozeReopenTimer = setTimeout(() => this.openAfterSnooze(), ms);
  }

  private openAfterSnooze() {
    const minutes = this.reminderMinutes;
    this.snoozeHiddenGuid = null;
    this.reminderMinutes = 5;
    this.clearSnoozePersist();
    this.setFolderHideshow(true, true);
    this.getTask(undefined, minutes);
  }

  /**
   * On init
   */
  displayWindowSize() {
    // if (document.documentElement.clientWidth < 1280) {
    //     $('.navbar-fuse-sidebar').removeClass('open locked-open');
    //     $('.overlaywrap').remove();
    // } else {
    //     $('.navbar-fuse-sidebar').addClass('open locked-open');
    // }
  }

  /**
   * It runs once after the component's view has been fully initialized.
   */
  ngOnInit(): void {
    this.checkLoginUser();

    this.behaviorService.isNotificationsOpen$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((isOpen) => {
        this.isNotificationsOpen = isOpen;
        this.cd.markForCheck();
      });

    this.behaviorService.isQuickPanelOpen$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((isOpen) => {
        this.isQuickPanelOpen = isOpen;
        this.cd.markForCheck();
      });

    this.behaviorService.isTimerPinned$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((isPinned) => {
        this.isTimerPinned = isPinned;
        this.cd.markForCheck();
      });

    this.behaviorService.rightSidebarWidth$
      .pipe(takeUntil(this._unsubscribeAll))
      .subscribe((width) => {
        this.rightSidebarWidth = this.isLoggedInUser ? width : 0;
        this.cd.markForCheck();
      });

    this._fuseConfigService.config.pipe(takeUntil(this._unsubscribeAll)).subscribe((config) => {
      this.fuseConfig = config;
    });
    if (localStorage.getItem('currentUser')) {
      this.restoreSnoozeState();
      this.getTask();
    }
    this.intervel = setInterval(() => this.getTask(), 300000);
    // window.addEventListener('resize', this.displayWindowSize);
    // if (this.preferenceObjectData && this.preferenceObjectData.NAVBARFOLDED) {
    //     setTimeout(() => {
    //         $('.navbar-fuse-sidebar').addClass('folded');
    //     }, 1000);
    // }
  }

  /**
   * It runs only once after the component's view has been rendered.
   */
  ngAfterViewInit() {
    this.cd.detectChanges();
    // $('.time_entry_sidebar').mouseover(function() {
    //     $('body').css('--spaceRight', '310px');
    // });

    // // Mouseout event
    // $('.time_entry_sidebar').mouseout(function() {
    //     console.log('out1111');
    //         $('body').css('--spaceRight', '70px');
    // });
  }

  /**
   * This function is used to get the task.
   */
  getTask(excludeTaskGuid?: string, reminderMinutes = 5) {
    let currentUser = JSON.parse(localStorage.getItem('currentUser'));
    if (currentUser && currentUser.UserGuid && currentUser.SessionToken) {
      let refectorPayload = {
        Filters: {
          HASREMINDER: true,
          HASREMINDERMINUTES: reminderMinutes,
          USERGUID: currentUser.UserGuid,
        },
        BACKGROUND: true,
        Action: 'GetData',
      };

      //old changes -> {HASREMINDER: true, HASREMINDERMINUTES: 5, USERGUID: currentUser.UserGuid, "BACKGROUND": true} on refectorPayload place
      this._mainAPiServiceService.getSetData(refectorPayload, 'task').subscribe({
        next: (res: any) => {
          if (res.CODE == 200 && res.STATUS == 'success') {
            this.taskData = res.DATA.TASKS || [];
            const hideGuid = excludeTaskGuid || this.snoozeHiddenGuid;
            if (hideGuid) {
              this.taskData = this.taskData.filter((t) => t.TASKGUID !== hideGuid);
            }
            this.isTaskData = !!this.taskData[0] || !!this.snoozeHiddenGuid;
            this.cd.markForCheck();
          }
        },
        error: (err: any) => {
          console.error(err);
        },
      });
    }
  }

  get registrationNotice(): {
    tone: 'brand' | 'warning' | 'danger';
    actionLabel: string;
    dismissible: boolean;
  } | null {
    const status = this.UserData?.REGISTRATIONSTATUS;
    const message = this.UserData?.REGISTRATIONMESSAGE;
    if (!status || !message) {
      return null;
    }
    if (status === 'Trial Expired') {
      return {
        tone: 'danger',
        actionLabel: 'Click here to subscribe to SILQ',
        dismissible: false,
      };
    }
    if (!this.isOpenNotifications) {
      return null;
    }
    if (status === 'Using New UI') {
      return { tone: 'brand', actionLabel: '', dismissible: true };
    }
    if (status === 'Current Trial') {
      return {
        tone: 'brand',
        actionLabel: 'Click here to subscribe to SILQ',
        dismissible: true,
      };
    }
    if (status === 'Trial Expires Soon') {
      return {
        tone: 'warning',
        actionLabel: 'Click here to subscribe to SILQ',
        dismissible: true,
      };
    }
    if (status === 'Grace Period') {
      return {
        tone: 'danger',
        actionLabel: 'Click here to update your payment details',
        dismissible: true,
      };
    }
    if (status === 'Expired' || status === 'Expires Soon') {
      return {
        tone: 'danger',
        actionLabel: 'Click here to update your payment details',
        dismissible: false,
      };
    }
    return null;
  }

  /**
   * This function is used to close the notification.
   */
  CloseNotification() {
    this.isOpenNotifications = false;
    this.behaviorService.permissionCheckforHeight$.next(false);
  }

  CloseWarning() {
    this.isOpenWarning = false;
  }

  toggleSidebar(): void {
    const isCollapsed = !this.isSidebarCollapsed();

    localStorage.setItem('sidebar_fold_unfold', JSON.stringify(isCollapsed));
    this.behaviorService.setMenuFoldUnfold(isCollapsed);

    setTimeout(() => {
      window.dispatchEvent(new Event('resize'));
    }, 310);
  }

  checkLoginUser(): void {
    this.currentUser = JSON.parse(localStorage.getItem('currentUser') || '{}');

    this.isLoggedInUser = !!this.currentUser?.UserGuid;
  }

  /**
   * On destroy
   */
  ngOnDestroy(): void {
    this._unsubscribeAll.next(null);
    this._unsubscribeAll.complete();
    clearTimeout(this.intervel);
    clearTimeout(this.snoozeReopenTimer);
  }
}
